import EnumDataSource from "../utils/enum-data-source.util";

export const PRIMARY_POLICY_CATEGORY = 1;
export const SECONDARY_POLICY_CATEGORY = 2;
export const TERTIARY_POLICY_CATEGORY = 3;
export const OTHER_POLICY_CATEGORY = 99;

const insurancePolicyCategories = {
  [PRIMARY_POLICY_CATEGORY]: "Primary",
  [SECONDARY_POLICY_CATEGORY]: "Secondary",
  [TERTIARY_POLICY_CATEGORY]: "Tertiary",
  [OTHER_POLICY_CATEGORY]: "Other"
};

export const INSURANCE_POLICY_CATEGORIES = new EnumDataSource(
  insurancePolicyCategories
);

const insurancePolicyTypes = {
  "1": "Commercial",
  "2": "PPO",
  "3": "HMO",
  "4": "EPO",
  "5": "POS",
  "6": "SNP",
  "7": "Medicaid",
  "8": "Workers Compensation",
  "9": "Third Party",
  "10": "Medicare",
  "11": "Supplement",
  "12": "HDHP"
};

export const INSURANCE_POLICY_TYPES = new EnumDataSource(insurancePolicyTypes);

// Mirrors backend `PolicyholderRelationship` IntegerChoices. Intentionally
// kept separate from `contactRelationship` (used for emergency contacts) —
// the two enums share a common ancestor but the backend rejects values that
// only exist on `ContactRelationship` (Friend, Grandchild, Guardian, Relative).
export const POLICYHOLDER_RELATIONSHIP_SELF = "0";
export const POLICYHOLDER_RELATIONSHIP_OTHER = "99";

const policyholderRelationship = {
  [POLICYHOLDER_RELATIONSHIP_SELF]: "Self",
  "1": "Spouse",
  "2": "Sibling",
  "3": "Parent",
  "4": "Child",
  "5": "Partner",
  "6": "Caregiver",
  [POLICYHOLDER_RELATIONSHIP_OTHER]: "Other"
};

export const INSURANCE_POLICY_HOLDER_RELATIONSHIPS = new EnumDataSource(
  policyholderRelationship
);
